// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PlacingOrder_wrapper__iBDUm","rightContent":"PlacingOrder_rightContent__nANtj"};